import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PicCenterOutlinedSvg from "@ant-design/icons-svg/es/asn/PicCenterOutlined";
import AntdIcon from '../components/AntdIcon';
var PicCenterOutlined = function PicCenterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: PicCenterOutlinedSvg
  }));
};
PicCenterOutlined.displayName = 'PicCenterOutlined';
export default /*#__PURE__*/React.forwardRef(PicCenterOutlined);